import React, {Dispatch, SetStateAction, useRef} from 'react';

import {ReactComponent as CrossIcon} from 'assets/svg/cross.svg';
import {ReactComponent as FilterIcon} from 'assets/svg/filter.svg';
import {useOutsideClick} from 'utils/custom-hooks';

import {SortingIndicator} from '../sorting-indicator';

import {FilterContainer, FilterIconContainer, FilterIconCross, FilterTitle} from './styled';

interface Props {
    clickPosition: number;
    setClickPosition: (value: number) => void;
    currentFilter: string | null;
    setCurrentFilter: Dispatch<SetStateAction<null>>;
    column: any;
    filters: any;
    isFilterActive: (filters: any, id: string) => boolean;
}

export const FilterContent = ({
    clickPosition,
    setClickPosition,
    currentFilter,
    setCurrentFilter,
    column,
    filters,
    isFilterActive,
}: Props) => {
    const tooltipRef = useRef<HTMLDivElement>(null);

    useOutsideClick(tooltipRef, () => {
        if (currentFilter === column.id) {
            setCurrentFilter(null);
        }
    });

    return (
        <div
            style={{
                position: window.innerWidth - clickPosition > 330 ? 'initial' : 'relative',
            }}
        >
            <FilterIconContainer
                active={isFilterActive(filters, column.id)}
                onClick={(e: any) => {
                    setClickPosition(e.clientX);
                    setCurrentFilter(column.id);
                }}
            >
                <FilterIcon />
            </FilterIconContainer>
            <FilterContainer
                ref={tooltipRef}
                className={currentFilter === column.id ? 'visible' : 'hidden'}
                style={{
                    left: window.innerWidth - clickPosition > 330 ? 0 : -283,
                    top: window.innerWidth - clickPosition > 330 ? 0 : -9,
                }}
            >
                <FilterTitle>
                    <span>
                        <span style={{padding: '0px 5px'}}>{column.render('Header')}</span>
                        <SortingIndicator
                            isSorted={column.isSorted}
                            isSortedDesc={column.isSortedDesc}
                        />
                    </span>
                    <FilterIconContainer
                        active={isFilterActive(filters, column.id)}
                        onClick={() => {
                            setCurrentFilter(null);
                        }}
                    >
                        <FilterIcon />
                    </FilterIconContainer>
                    <FilterIconCross>
                        <CrossIcon onClick={() => setCurrentFilter(null)} />
                    </FilterIconCross>
                </FilterTitle>
                {column.render('Filter')}
            </FilterContainer>
        </div>
    );
};
